import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class SmartInsightsPropertyTagsUserModel extends Model {
  [Type] = 'smart-insights/property-tags/user' as const;

  @attr('string') declare name: string;
}
